import { buildDegreeAndCadenceStats } from './studentProgressInsights'

export { calculateStreak } from './dailyStreak'

/**
 * Calcule les stats de profil (degrés, cadences, moyennes) à partir des tentatives.
 * Délègue à buildDegreeAndCadenceStats (meilleur score par exercice pour la performance).
 */
export function computeProfileStatsFromAttempts(attempts) {
  return buildDegreeAndCadenceStats(attempts)
}
